/**
 * @file   src\Pages\MySubscriptions.tsx
 * @brief  MySubscriptions page.
 * @date   JUN, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { React, Link, useState, useNavigate, useParams, useEffect,Modal } from "../utils/thirdpartyComponents"
import { Badge, Button } from "react-bootstrap";
import "src/styles/inner-page-styles.scss";
import axios from "src/config/axiosConfig";
import { ProfileApi } from "src/utils/apiUrls";
import { MessageToaster } from "src/utils/toastUtil";

const CancelMySubscription = ({setShowcancelConfirmation,showcancelConfirmation,setLoading, fetchMySubscriptions, from, cancelSubscriptionID}:any) => { 


     // Instantiate MessageToaster
     const toaster = new MessageToaster();
    // const [loading,setLoading] =  useState(false);
    // const [showcancelConfirmation, setShowcancelConfirmation] = useState(false);
    //cancel confirmation modal close function
    const handleOnHide = () => {setShowcancelConfirmation(false)}

    
    //my subscription api integration
    const cancelSubscription = async () => {
        try {
          setLoading(true); // Show loader
          setShowcancelConfirmation(false)
          const responseCancelSubscription = await axios.post(ProfileApi.CANCEL_SUBSCRIPTIONS,
             {
              userSubscriptionId: cancelSubscriptionID
        });
          if (responseCancelSubscription?.data?.error === 0) {
            toaster.toastSuccess(responseCancelSubscription?.data?.message);
            if(from === 'mysubscription') {
              fetchMySubscriptions()
            } else {
             location.reload()
            }
          } else {
            toaster.toastError(responseCancelSubscription?.data?.message);
          }
        } catch (error: any) {
          throw new Error(error.response?.data?.message || error.message);
        } finally {
          setLoading(false); // Hide loader
          }
      };
          
         
   {/* cancel subscription confirmation modal */}
   return (
   <Modal
   show={showcancelConfirmation}
   onHide={handleOnHide}
   centered
   className='notification-modal'
 >
   <Modal.Body className='text-center'>
     <h6>You can use your current subscription until it expires. Are you sure you want to cancel it now?
     </h6>
   </Modal.Body>
   <Modal.Footer className='d-grid'>
     <Button variant="light" className="m-0" onClick={handleOnHide}>No</Button>
     <Button variant="primary" className='primary-btn btn-main m-0' onClick={()=>cancelSubscription()}>Yes</Button>
   </Modal.Footer>
 </Modal>
 
  )

}

export default CancelMySubscription;